import { useState, useRef, useEffect } from "react";
import {
  FaHome, FaShoppingBag, FaSearch, FaHeart, FaShoppingCart
} from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { apiFetch } from "../api";
import ProductModal from "./ProductModal";
import AadviIcon from "../assets/Aadvi-icon.png";
import "./BottomNavbar.css";

const BottomNavbar = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [isIconSpinning, setIsIconSpinning] = useState(false);
    const [isExtraNavbarOpen, setIsExtraNavbarOpen] = useState(false);

    const searchRef = useRef(null);
    const wishlist = useSelector((state) => state.wishlist);
    const cart = useSelector((state) => state.cart);
    const navigate = useNavigate();
    const location = useLocation();

    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        const normalize = (str) => str.toLowerCase().replace(/\s/g, "");
        const normalizedQuery = normalize(query);

        if (normalizedQuery === "") {
            setSearchResults([]);
            setShowSearchResults(false);
            return;
        }

        const filtered = products.filter((product) => {
            const normalizedName = normalize(product.name);
            return normalizedName.includes(normalizedQuery);
        });
        setSearchResults(filtered);
        setShowSearchResults(true);
    };

    useEffect(() => {
        const handleBottomSearch = (e) => {
            if (e.detail.open) {
                setShowSearchResults(false);
                setSearchQuery("");
            }
        };
        window.addEventListener('bottomSearchOpen', handleBottomSearch);
        return () => window.removeEventListener('bottomSearchOpen', handleBottomSearch);
    }, []);

    const shouldShowNoMatches = showSearchResults && searchQuery.trim() !== "" && searchResults.length === 0;

    useEffect(() => {
        const fetchProducts = async () => {
           
            const token = localStorage.getItem("token");
            if (!token) {
                setProducts([]); 
                return;
            }
            try {
                const data = await apiFetch("/api/products/all");
                if (data && data.data) {
                    setProducts(data.data);
                } else {
                    setProducts([]);
                }
            } catch (error) {
                setProducts([]);
            }
        };
        fetchProducts();
    }, [location]); 

    useEffect(() => {
        setShowSearchResults(false);
        setShowSearchBar(false);
        setSearchQuery("");
    }, [location]);

    useEffect(() => {
        const handleScroll = () => {
            setShowSearchResults(false);
            setShowSearchBar(false);
            setSearchQuery("");
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleExtraNavbar = () => {
        setIsIconSpinning(true);
        setIsExtraNavbarOpen(!isExtraNavbarOpen);
        setTimeout(() => setIsIconSpinning(false), 500); // Spin duration
    };

    useEffect(() => {
        const handleScroll = () => {
            setShowSearchResults(false);
            setShowSearchBar(false);
            setSearchQuery("");
            setIsExtraNavbarOpen(false); 
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        setShowSearchResults(false);
        setShowSearchBar(false);
        setSearchQuery("");
        setIsExtraNavbarOpen(false); // Close extra navbar on location change
    }, [location]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                searchRef.current &&
                !searchRef.current.contains(event.target)
            ) {
                setShowSearchResults(false);
                setShowSearchBar(false);
                setSearchQuery("");
            }
            // Close extra navbar if clicked outside
            const extraNavbar = document.querySelector('.extra-navbar');
            const aadviIcon = document.querySelector('.aadvi-icon');
            if (
                isExtraNavbarOpen &&
                extraNavbar &&
                !extraNavbar.contains(event.target) &&
                aadviIcon &&
                !aadviIcon.contains(event.target)
            ) {
                setIsExtraNavbarOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isExtraNavbarOpen]);

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
        setShowSearchResults(false);
        setShowSearchBar(false);
        setSearchQuery("");
    };

    const toggleSearchBar = () => {
        setShowSearchBar(!showSearchBar);
        if (showSearchBar) {
            setSearchQuery("");
            setShowSearchResults(false);
            window.dispatchEvent(new CustomEvent('bottomSearchOpen', { detail: { open: false } }));
        } else {
            window.dispatchEvent(new CustomEvent('bottomSearchOpen', { detail: { open: true } }));
        }
    };

    useEffect(() => {
        if (showSearchBar) {
            const input = document.querySelector('.bottom-search-input');
            if (input) input.focus();
        }
    }, [showSearchBar]);

    return (
        <>
            {isExtraNavbarOpen && (
                <div className="extra-navbar">
                    <div className="extra-nav-item" onClick={() => { navigate("/about"); setIsExtraNavbarOpen(false); }}>About</div>
                    <div className="extra-nav-item" onClick={() => { navigate("/contact"); setIsExtraNavbarOpen(false); }}>Contact</div>
                </div>
            )}
            <img
                src={AadviIcon}
                alt="Aadvi Icon"
                className={`aadvi-icon ${isIconSpinning ? (isExtraNavbarOpen ? 'spin-clockwise' : 'spin-counterclockwise') : ''}`}
                onClick={toggleExtraNavbar}
                style={{borderRadius:'50%', border:'2px solid #82278A', }}
            />
            <div className="bottom-navbar">
                <div className="bottom-nav-item" onClick={() => navigate("/")}><FaHome /><span>Home</span></div>
                <div className="bottom-nav-item" onClick={() => navigate("/products")}><FaShoppingBag /><span>Shop</span></div>
                <div className="bottom-nav-item" onClick={toggleSearchBar}><FaSearch /><span>Search</span></div>
                <div className="bottom-nav-item" onClick={() => navigate("/wishlist")}>
                    <FaHeart />
                    {wishlist.itemCount > 0 && <span className="badge" style={{marginLeft:'18px', borderRadius:'50%', fontWeight:'normal', display:'flex', justifyContent:'center'}}>{wishlist.itemCount}</span>}
                    <span>Wishlist</span>
                </div>
                <div className="bottom-nav-item" onClick={() => navigate("/cart")}>
                    <FaShoppingCart />
                    {cart.itemCount > 0 && <span className="badge" style={{marginLeft:'18px', borderRadius:'50%', fontWeight:'normal', display:'flex', justifyContent:'center'}}>{cart.itemCount}</span>}
                    <span>Cart</span>
                </div>
            </div>
            {showSearchBar && (
                <div className="bottom-search-container">
                    <input
                        className="bottom-search-input" type="search"
                        placeholder="Search products..." value={searchQuery}
                        onChange={handleSearch}
                    />
                    {(showSearchResults && searchQuery.trim()) && (
                        <div ref={searchRef} className="bottom-search-results">
                            {searchResults.length > 0 ? (
                                searchResults.map((result) => (
                                    <div
                                        key={result._id}
                                        className="dropdown-item text-dark"
                                        style={{ cursor: "pointer", borderBottom: "1px solid black", height: "40px", display: "flex", alignItems: "center" }}
                                        onClick={() => {
                                            setSelectedProduct(result);
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        {result.name}
                                    </div>
                                ))
                            ) : shouldShowNoMatches ? (
                                <div style={{ color: "red", padding: "8px" }}>No Matches Found</div>
                            ) : null}
                        </div>
                    )}
                </div>
            )}
            <ProductModal post={selectedProduct} isOpen={isModalOpen} onClose={closeModal} />
        </>
    );
};

export default BottomNavbar;